import 'whatwg-fetch';
import { createStore } from '@vfde-sails/core';
import authentication from './container/Authentication';

createStore();
authentication();
